import Button from '@/features/ui/buttons/components/Button'
import CheckmarkIcon from '@/features/ui/icons/components/CheckmarkIcon'
import { FC } from 'react'
import { StyleProp, StyleSheet, TextStyle, ViewStyle } from 'react-native'

interface ConstructiveButtonProps {
    children: string
    disabled?: boolean
    loading?: boolean
    icon?: boolean
    onPress: () => void
    style?: StyleProp<ViewStyle>
    textStyle?: StyleProp<TextStyle>
}

const ConstructiveButton: FC<ConstructiveButtonProps> = ({
    children,
    disabled,
    loading,
    icon,
    onPress,
    style,
    textStyle,
}) => {
    const text = children + (loading ? '...' : '')

    return (
        <Button
            disabled={disabled}
            color="action"
            FrontIcon={icon ? CheckmarkIcon : undefined}
            onPress={onPress}
            style={[styles.button, style]}
            textStyle={textStyle}
        >
            {text}
        </Button>
    )
}

const styles = StyleSheet.create({
    button: {
        flexGrow: 1,
        justifyContent: 'center',
        height: 44,
        maxWidth: 164,
    },
})

export default ConstructiveButton
